export enum SignupFlag {
  NONE,
  ACCOUNT_ADMIN,
  ACCOUNT_LIMIT,
  ACCOUNT_INVITED,
  ACCOUNT_REQUESTS_JOIN
}
